// tps-home-rows · The Shelf (Midas home rows A). Loaded as a module, so it runs once however many rows the page has.
// 1) No dead space: when a short row ends before the right edge, the See-all tile takes the leftover width (max 2 columns).
//    Only the tile's width changes; nothing above or below moves.
// 2) Mouse drag on desktop strips. Touch and trackpads scroll natively. No arrows, no motion.
// 3) Keyboard: a focused card is never left half under the edge.
// 4) Back keeps each row where it was (Hermes H-HR-02): scrollLeft per row index in sessionStorage, restored on a back/forward load.
const strips = document.querySelectorAll('.tps-hr__s');
function fill() {
  strips.forEach((s) => {
    const e = s.querySelector('.tps-hr__end');
    const c = s.querySelector('.tps-hr__c');
    if (!e || !c) return;
    e.style.gridColumn = '';
    const cs = getComputedStyle(s);
    const gap = parseFloat(cs.columnGap) || 0;
    const pad = parseFloat(cs.paddingRight) || 0;
    const sr = s.getBoundingClientRect();
    const free = s.clientWidth - pad - (e.getBoundingClientRect().right - sr.left + s.scrollLeft);
    const unit = c.getBoundingClientRect().width + gap;
    const extra = Math.floor((free + 1) / unit);
    if (extra > 0) e.style.gridColumn = 'span ' + Math.min(2, 1 + extra);
  });
}
fill();
let rt = 0;
addEventListener('resize', () => { cancelAnimationFrame(rt); rt = requestAnimationFrame(fill); });
strips.forEach((s) => {
  let x0 = 0, l0 = 0, down = false, moved = false;
  s.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; x0 = e.clientX; l0 = s.scrollLeft; });
  addEventListener('pointermove', (e) => { if (!down) return; const d = e.clientX - x0; if (Math.abs(d) > 4) { moved = true; s.classList.add('is-drag'); } if (moved) s.scrollLeft = l0 - d; });
  addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => s.classList.remove('is-drag'), 0); });
  s.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
  s.addEventListener('dragstart', (e) => e.preventDefault());
  // keyboard: a focused card that sits under the edge (the peek) is brought fully into the row
  s.addEventListener('focusin', (e) => {
    const c = e.target.closest('.tps-hr__c'); if (!c) return;
    const pad = parseFloat(getComputedStyle(s).paddingLeft) || 0, r = c.getBoundingClientRect(), sr = s.getBoundingClientRect();
    if (r.right > sr.right - pad + 1) s.scrollLeft += r.right - (sr.right - pad);
    else if (r.left < sr.left + pad - 1) s.scrollLeft -= (sr.left + pad) - r.left;
  });
});

const KEY = 'tps-hr-x';
try {
  const nav = performance.getEntriesByType('navigation')[0];
  if (nav && nav.type === 'back_forward') {
    const xs = JSON.parse(sessionStorage.getItem(KEY) || '[]');
    strips.forEach((s, i) => { if (xs[i] > 0) { s.style.scrollSnapType = 'none'; s.scrollLeft = xs[i]; requestAnimationFrame(() => { s.style.scrollSnapType = ''; }); } });
  }
} catch (e) {}
addEventListener('pagehide', () => { try { sessionStorage.setItem(KEY, JSON.stringify([...strips].map((s) => Math.round(s.scrollLeft)))); } catch (e) {} });
